// Dependencies
import clsx from 'clsx';
import { isSameDay, isWeekend } from 'date-fns';
import React, { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
// Core & Lab
import TableCell from '@mui/material/TableCell';
// Actions
import { updateStocksStock } from './redux/reducer';
// Types
import { Tooltip } from '@mui/material';
import { utcToZonedTime } from 'date-fns-tz';
import { AppState } from '../../reducers';

type ChannelManagerStockCalendarStockCellProps = {
    room_id: number,
    stock_index: number,
    stock: any // TODO change type to real type
}

const ChannelManagerStockCalendarStockCell: FC<ChannelManagerStockCalendarStockCellProps> = ({ room_id, stock_index, stock }): ReactElement | null => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const stocks_edit_mode = useSelector((state: AppState) => state.channelManager.stocks_edit_mode);
    const selected_contract = useSelector((state: AppState) => state.channelManager.contract_selected);
    const onChangeStock = (index: number, stock_value: string | number) => () => {
        if (stocks_edit_mode === 'STOCK') {
            dispatch(updateStocksStock({ room_id, stock, index, stock_value }));
        }
    };
    if (stock.id === null && stock.price === null) {
        return <TableCell className={clsx('ft-roomStockCell', { ['ft-roomStockCellWeekEnd']: isWeekend(new Date(stock.date)) })} />;
    } else {
        let price_start_date = new Date(stock.price.start_date);
        const price_end_date = new Date(stock.price.end_date);
        let index = 0;
        while (price_start_date < stock.date && price_start_date <= price_end_date) {
            price_start_date = new Date(price_start_date.setDate(price_start_date.getDate() + 1));
            index++;
        }
        let stock_type = null;
        stock.price.real_stock?.forEach((real_stock: any) => {
            if (isSameDay(utcToZonedTime(real_stock.date + 'T00:00:00Z', 'Etc/UTC'), price_start_date)) {
                stock_type = real_stock.stock_type;
            }
        });
        let is_on_demand = false;
        let is_free_sales = false;
        if (!stock_type) {
            is_on_demand = selected_contract?.second_stock_type === 'ON_DEMAND';
            is_free_sales = selected_contract?.second_stock_type === 'FREELANCE';
        } else {
            is_on_demand = (stock_type === 'ON_DEMAND');
            is_free_sales = stock_type === 'FREELANCE';
        }
        let stock_value: string | number = '';
        if (stock.price.stocks !== undefined && stock.price.stocks !== null && index < stock.price.stocks.length && !isNaN(stock.price.stocks[index])) {
            stock_value = stock.price.stocks[index];
        }
        return <Tooltip title={is_on_demand ? t('shared.sale-in-demand') : is_free_sales ? t('shared.free-sale') : stock_value === 0 && !is_on_demand ? t('shared.sale-closed') : ""}>
            {/* <TableCell className={clsx('ft-roomStockCell', { ['ft-roomStockCellWeekEnd']: isWeekend(new Date(stock.date)), ['ft-roomStockCellEdit']: stocks_edit_mode === 'STOCK' }, { ['ft-roomStockCellOnDemand']: is_on_demand }, { ['ft-roomStockCellFreelance']: is_free_sales }, { ['ft-roomStockCellNotOnDemand']: stock_value === 0 && !is_on_demand })} align={'center'} onClick={onChangeStock(index, stock_value)}>{stock_value}</TableCell> */}
            <TableCell className={clsx('ft-roomStockCell', { ['ft-roomStockCellWeekEnd']: isWeekend(new Date(stock.date)), ['ft-roomStockCellEdit']: stocks_edit_mode === 'STOCK' }, { ['ft-roomStockCellFreelance']: is_free_sales }, { ['ft-roomStockCellNotOnDemand']: stock_value === 0 && !is_on_demand })} align={'center'} onClick={onChangeStock(index, stock_value)}>{stock_value}</TableCell>
        </Tooltip>;
    }
};

export default React.memo(ChannelManagerStockCalendarStockCell);